// eslint-disable-next-line
/* eslint-disable */

import { apiVoucher, relatorioService } from './config'
import request from './request'

export default {
    refreshToken(token, idLocal, idUnidade) {
        var obj = {
            idLocal: idLocal,
            idUnidade: idUnidade,
            token: token,
        }
        return request({
            url: '/posAtendimento/refreshToken',
            method: 'post',
            data: obj
        })
    },
    // Listar os pos-atendimnetos do dia por idUnidade
    buscarPosAtendimentoDia(idUnidade) {
        return request({
            url: `/posAtendimento/buscar?idUnidade=${idUnidade}`,
            method: 'get'
        })
    },
    listarConsultas(idAtendimento) {
        return request({
            url: `/posAtendimento/listarConsultas?idAtendimento=${idAtendimento}`,
            method: 'get'
        })
    },
    listarSolicitacaoExames(idSolicitacao, idPosConsulta) {
        return request({
            url: `/posAtendimento/listarSolicitacaoExames?idSolicitacao=${idSolicitacao}&idPosConsulta=${idPosConsulta}`,
            method: 'get'
        })
    },
    listarSolicitacaoExamesPorIdPos(idPosConsulta) {
        return request({
            url: `/posAtendimento/listarSolicitacaoExames?idPosConsulta=${idPosConsulta}`,
            method: 'get'
        })
    },
    listarSolicitacaoMedicamentos(idConsulta) {
        return request({
            url: `/posAtendimento/listarSolicitacaoMedicamentos?idConsulta=${idConsulta}`,
            method: 'get'
        })
    },
    alterarStatusPosAtendimento(idAtendimento, status) {
        var obj = {
            idAtendimento: idAtendimento,
            status: status
        }
        return request({
            url: `/posAtendimento/alterarStatusPosAtendimento`,
            method: 'post',
            data: obj
        })
    },
    cadastrarSolicitacaoDeExames (data) {
        return request({
            url: `/posAtendimento/cadastrarSolicitacaoDeExames`,
            method: 'post',
            data: data
        })
    },

    consultarOrcamento(data) {
        console.log('api/orcamento', data);
        return apiVoucher.post('api/orcamento', data)
    },
    gerarVoucher(data) {
        console.log('api/voucher:')
        console.log(data)
        return apiVoucher.post('api/voucher', data)
    },
    downloadRelatorioOrcamento: (data) => {
        return relatorioService.post('Relatorio/rest/atendimento/orcamento', data, {
          responseType: 'blob'
        })
      },
      downloadRelatorioVoucher: (data) => {
        return relatorioService.post('Relatorio/rest/atendimento/voucher', data, {
          responseType: 'blob'
        })
      },

    fazerChamada(idAtendimento, codigo, nomeConsultorio, nomeMedico,
        nomePaciente, prioridade, idLocalMedico, nomeLocal, tecnico, automatico, idLocal, 
        idUnidade) {
        var obj = {
                codigo: codigo,
                idAtendimento: idAtendimento,
                nomeConsultorio: nomeConsultorio,
                nomeMedico: nomeMedico,
                nomePaciente: nomePaciente,
                prioridade: prioridade,
                idLocalMedico: idLocalMedico,
                nomeLocal: nomeLocal,
                tecnico: tecnico,
                automatico: automatico,
                idLocal: idLocal,
                idUnidade: idUnidade
            }
            //return api.post('/medico/fazerChamada',obj)
            console.log(obj)
        return request({
            url: '/posAtendimento/fazerChamada/',
            method: 'post',
            data: obj
        })
    },
    finalizarPosConsultas(consultas) {
        return request({
            url: '/posAtendimento/finalizarPosConsulta',
            method: 'post',
            data: consultas
        })
    },
    buscarPacientesConsultasPorData: (idMedico, data) => {
        //console.log(data)
        return request({
            url: `posAtendimento/buscarPacientesConsultasPorData?idMedico=${idMedico}&date=${data}`,
            method: 'GET',
        })
    },


}